import { request } from "../index"

export async function getStates() {
    return request({ "url": "state-location/" })
}
export async function getCities(params = {}) {
    return request({ "url": "city-location/", params })
}


// WEBPACK FOOTER //
// ./src/api/address/index.js